module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "id": "ch4",
      "title": "CHAPTER 4"
    }
  }, [_c('header', [_c('p', {
    staticClass: "h2f"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "title": "34"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rch4"
    }
  }, [_vm._v("CHAPTER 4")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _vm._v("idan lounged in a faded red armchair with padding erupting from several holes in the middle of patches of frayed material. A warm fire crackled nearby, and he’d placed a jug of spiced wine next to it to heat. His arm was tightly bound in a sling against his chest. The physikers had taken their sweet time seeing to it. After they’d set the arm, they’d tried to give him more oil of the poppy, but he’d had enough of dulled senses for the time being.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Riversedge was almost in chaos. From what he’d heard, the jukari horde hadn’t even reached the city when the emperor’s forces had been butchered. With only a fraction of that army remaining, Aidan doubted the vormag would hesitate. They would set the jukari on the remnants and use their foul sorcery to destroy what they could.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He reached across and poured himself a mug of the wine, sipping at it without noticing the taste.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Across the room from him, Vasile was fast asleep in his own dilapidated armchair. The magistrate’s arm was in worse shape than Aidan’s, "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_35",
      "title": "35"
    }
  }, [_vm._v("and they’d almost amputated the limb. As "), _c('i', [_vm._v("bad a break as we’ve ever seen,")]), _vm._v(" one of the physikers had said. Only Aidan interceding on Vasile’s behalf had stopped them. Eventually, they’d agreed there was a slight chance the arm could be saved.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It hadn’t been easy for Aidan to find Vasile, but his writ from the emperor opened doors and mouths that would normally have remained closed to him. He’d found the magistrate being tended to by the physikers seconded to Riversedge’s Quivers. Aidan had followed the trail cel Rau had left and barged his way into the Quivers’ main barracks, disappointed at finding only Vasile, but at the same time relieved the magistrate had made it to safety.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Word of his writ had spread throughout the Quivers, and soon he’d been summoned to a meeting with Riversedge’s commander, a man by the name of Cilliers. From what Aidan could tell, Commander Cilliers hadn’t left his “strategy room” to observe the jukari forces, let alone address the Quivers holding the walls.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He snorted in disgust at the thought of meeting the man, and Vasile stirred, disturbed by the noise.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Aidan sipped at his wine and realized the cup was empty. He began to refill it, paused, then continued to pour.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vasile shifted and opened one eye. It was a few moments before he seemed able to focus his gaze on Aidan. He ran his tongue over parched lips and cleared his throat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I . . . don’t suppose that’s . . . water?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s some next to you. The physikers said you’d wake soon. I don’t think you’ll want to move just yet. You need time to adjust.” Aidan slurped a mouthful from his cup and set it down. With a groan, he levered himself to his feet and shuffled over to Vasile. He reached down and handed a jug filled with water to the magistrate. There was a hollow reed poking out the top, which Vasile looked askance at.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Use it,” said Aidan. “The physikers keep them for patients who have limited use of their arms and hands.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vasile sucked water through the reed while Aidan restrained himself from asking the hundred questions he had tumbling around in his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_36",
      "title": "36"
    }
  }, [_vm._v("Vasile drained more than half the jug before pushing the reed out with his tongue and turning his head away. “Thank you,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Aidan set the water down and returned to his chair. “Tell me what happened to you, cel Rau, and Chalayan at the bridge. And what happened after.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vasile screwed his face up in a grimace. He looked sicker than before, if that were possible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re not going to like what I have to say.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There are many things I don’t like in this world, bad news among them. But I’ve heard enough terrible things not to balk at hearing any now. I need to know what’s going on.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vasile nodded. “Cel Rau . . . killed Chalayan. Right after the sorcery on the bridge. He—we—thought you were dead. How is it you’re alive?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“All in good time, Vasile. Tell me of Chalayan’s death, and what came after.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Swallowing, Vasile nodded again.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1433814a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062407290_Chapter_4.vue
// module id = 84
// module chunks = 0